import { render, staticRenderFns } from "./talent6.vue?vue&type=template&id=d4a59e7a&scoped=true"
import script from "./talent6.vue?vue&type=script&lang=js"
export * from "./talent6.vue?vue&type=script&lang=js"
import style0 from "./talent6.vue?vue&type=style&index=0&id=d4a59e7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a59e7a",
  null
  
)

export default component.exports